import { getApiTable } from "./qmsApiUtils";
import { getVaultDocumentDisplayName, getVaultDocumentListId } from "./qmsVaultUtils";
import { formatVaultTableDate } from "./qmsVaultWorkspaceUtils";

function readRowValue(row, ...keys) {
  for (const key of keys) {
    const value = row?.[key];
    if (value != null && String(value).trim() !== "") return value;
  }
  return "";
}

function parseVersionSortValue(row) {
  const version = Number(row?.VersionNumber);
  if (Number.isFinite(version)) return version;
  const superseded = Date.parse(String(row?.SupersededDateTime || row?.SystemDateTime || ""));
  return Number.isFinite(superseded) ? superseded / 1_000_000_000 : 0;
}

export function normalizeVaultVersionHistoryRow(row, index = 0) {
  const documentId = String(row?.DocumentId || "").trim();
  const versionNumber = readRowValue(row, "VersionNumber", "versionNumber");
  const owner = formatVaultTableDate(readRowValue(row, "CreatedBy", "createdBy"));
  const modified = formatVaultTableDate(readRowValue(row, "SystemDateTime", "systemDateTime"));
  const supersededBy = formatVaultTableDate(readRowValue(row, "SupersededBy", "supersededBy"));
  const supersededOn = formatVaultTableDate(
    readRowValue(row, "SupersededDateTime", "supersededDateTime"),
  );

  return {
    id: documentId || `version-${index}`,
    row,
    documentId: getVaultDocumentListId(row),
    displayTitle: getVaultDocumentDisplayName(row),
    versionLabel: versionNumber !== "" && versionNumber != null ? `V${versionNumber}` : "—",
    versionNumber: versionNumber !== "" && versionNumber != null ? String(versionNumber) : "—",
    owner,
    modified,
    supersededBy,
    supersededOn,
    sortValue: parseVersionSortValue(row),
  };
}

export function getVaultVersionHistoryEntries(response) {
  const rows = getApiTable(response, "PreviousVersionDocuments");
  return (Array.isArray(rows) ? rows : [])
    .map((row, index) => normalizeVaultVersionHistoryRow(row, index))
    .sort(
      (a, b) =>
        b.sortValue - a.sortValue ||
        String(b.supersededOn).localeCompare(String(a.supersededOn)) ||
        String(b.id).localeCompare(String(a.id)),
    );
}
